<template>
  <NuxtLink
    :to="to"
    :class="[
      isShadow ? 'shadow' : '',
      isDisabled ? 'opacity-70' : '',
      sizeClass,
      isLoading ? loadingClass : isWarning ? warningClass : defaultClass,
      isLean ? 'h-8' : 'h-10',
      isSmallRadius ? 'rounded-md before:rounded-md' : 'rounded before:rounded',
      classes,
    ]"
    class="font-medium before:content-[''] before:-z-10 before:box-content relative before:absolute before:-inset-2 text-sm lg:text-base flex justify-center items-center"
    :type="type"
    :id="id"
  >
    {{ text }}
  </NuxtLink>
</template>

<script>
export default {
  props: {
    classes: {
      type: String,
      required: false,
      default: "",
    },
    text: {
      type: String,
      required: false,
      default: "دکمه",
    },
    id: {
      type: String,
      required: false,
    },

    styleType: {
      type: String,
      required: false,
      default: "primary",
      validate: () =>
        "primary" || "secondary" || "tertiary" || "icon" || "shadow",
    },
    size: {
      type: String,
      required: false,
      default: "md",
      validate: () => "sm" || "md" || "2xl" || "full",
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLean: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSmallRadius: {
      type: Boolean,
      required: false,
      default: false,
    },
    isWarning: {
      type: Boolean,
      required: false,
      default: false,
    },
    isShadow: {
      type: Boolean,
      required: false,
      default: false,
    },
    to: {
      type: String,
      default: '/',
    },
  },
  setup(props) {
    const sizeClass = computed(
      () =>
        (props.size === "sm" && "w-28 lg:w-32") ||
        (props.size === "md" && "w-32 lg:w-36") ||
        (props.size === "2xl" && "w-36 lg:w-48") ||
        (props.size === "full" && "w-full")
    );
    const defaultClass = computed(
      () =>
        (props.styleType === "primary" &&
          "bg-blue-500 text-white fill-white  before:active:border-10 before:active:border-primary-300") ||
        (props.styleType === "secondary" &&
          "bg-white text-blue-500 fill-blue-500 border border-blue-500 before:active:border-10 before:active:border-primary-300") ||
        (props.styleType === "tertiary" &&
          "bg-white text-blue-500 underline underline-offset-8 hover:text-primary-600 hover:underline-primary-600") ||
        (props.styleType === "icon" && "bg-transparent") ||
        (props.styleType === "shadow" &&
          "bg-white w-full shadow-xl text-blue-500")
    );
    const disabledClass = computed(
      () =>
        (props.styleType === "primary" &&
          "bg-primary-400 text-white fill-white cursor-not-allowed") ||
        (props.styleType === "secondary" &&
          "bg-white text-primary-400 fill-primary-400 border border-primary-400 cursor-not-allowed") ||
        (props.styleType === "tertiary" &&
          "bg-white text-primary-400 underline underline-offset-8 underline-primary-400 cursor-not-allowed") ||
        (props.styleType === "icon" && "bg-transparent")
    );
    const loadingClass = computed(
      () =>
        (props.styleType === "primary" && "bg-blue-500 cursor-wait") ||
        (props.styleType === "secondary" &&
          "bg-white text-blue-500 border border-blue-500 cursor-wait") ||
        (props.styleType === "tertiary" && "") ||
        (props.styleType === "icon" && "bg-transparent")
    );
    const loadingBarClass = computed(
      () =>
        (props.styleType === "primary" && "text-blue-500 fill-white") ||
        (props.styleType === "secondary" && "text-white fill-blue-500") ||
        (props.styleType === "tertiary" && "text-white") ||
        (props.styleType === "icon" && "bg-transparent")
    );
    const warningClass = computed(
      () =>
        "bg-warning hover:bg-warning before:active:border-10 before:active:border-primary-300"
    );
    return {
      sizeClass,
      defaultClass,
      disabledClass,
      loadingClass,
      loadingBarClass,
      warningClass,
    };
  },
};
</script>
